// Bearer-token helpers shared by every authenticated API call.
//
// The token is issued by /api/login and /api/register and stored in
// localStorage. authHeaders() merges it into a fetch headers object so callers
// don't have to repeat the Authorization wiring at each call site.

export function getAuthToken() {
  return localStorage.getItem('auth_token') || '';
}

export function authHeaders(extra = {}) {
  const headers = { ...extra };
  const token = getAuthToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}
